import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import CollectionCard from 'marketplace-ui-common/collections/components/CollectionCard';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { getIsInApp } from '../../selectors/app';
import { getThemesStorefrontRoute } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_COLLECTIONS_PER_PAGE = 24;
export default function ThemeCollectionsSection({
  trackInteraction
}) {
  const isInApp = useSelector(getIsInApp);
  const {
    getDisplayedCollections,
    requestState
  } = usePublishedCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const {
    columns
  } = useResponsiveProps({
    columns: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.MD]: 2,
      [ScreenSizes.LG]: 3
    }
  });
  const [page, setPage] = useState(1);
  const displayedCollections = getDisplayedCollections();
  const offset = (page - 1) * MAX_COLLECTIONS_PER_PAGE;
  const limit = displayedCollections.length && displayedCollections.length <= MAX_COLLECTIONS_PER_PAGE * page ? displayedCollections.length : offset + MAX_COLLECTIONS_PER_PAGE;
  const currentCollections = displayedCollections.slice(offset, limit);
  const pageCount = Math.ceil(displayedCollections.length / MAX_COLLECTIONS_PER_PAGE);
  const needsPagination = pageCount > 1;
  const handlePageChange = useCallback(newPage => {
    setPage(newPage);
    trackInteraction('change collections page', {
      page: newPage
    });
  }, [trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingWrapper, {
      requestStatus: requestState,
      children: /*#__PURE__*/_jsx(CardGrid, {
        columns: columns,
        paddingBlockEnd: "1000",
        paddingInline: "500",
        marginInline: "1300",
        children: currentCollections.map((collection, index) => collection.publishedListing && /*#__PURE__*/_jsx(RouterLink, {
          alignItems: "stretch",
          blockSize: "100%",
          display: "flex",
          to: getThemesStorefrontRoute(collection.publishedListing.slug),
          use: "unstyled",
          children: /*#__PURE__*/_jsx(CollectionCard, {
            collection: collection
          })
        }, `collection-${collection.id}-${index}`))
      })
    }), needsPagination && /*#__PURE__*/_jsx(Paginator, {
      onPageChange: ({
        target: {
          value
        }
      }) => handlePageChange(value),
      pageCount: pageCount
    })]
  });
}